import { GetServerSideProps } from 'next';
import { PartnerPages } from '../../../../../components/partner-pages/page';
import PartnerPageDataService from '../../../../../components/partner-pages/services/partner-pages.service';
import { render404Page } from '../../../../../utils/UtilFunctions';
import { transformCorporatePage } from '../../../../../utils/static-pages/partnerPages';
import { PartnerPagesProps } from '../../../../clear-frontier/preview/s/[static]';

const PartnerPage: React.FC<PartnerPagesProps> = ({
  postData,
  metaData,
}): JSX.Element => {
  return <PartnerPages postData={postData} metaData={metaData} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { params } = context;
  try {
    const resData = await PartnerPageDataService.getPartnerPageBySlug(
      params?.partner as string
    );
    const resMeta = await PartnerPageDataService.getMetaDataServerSide();

    let responseData, responseDataMeta;
    if (resMeta.status === 200) {
      responseDataMeta = await resMeta.data;
    }
    if (resData.status === 200) {
      responseData = await resData.data;
      return {
        props: {
          postData: transformCorporatePage(responseData.data),
          metaData: responseDataMeta.data,
        },
      };
    }
    return render404Page();
  } catch (error: unknown) {
    console.log(
      error instanceof Error ? error.message : 'Unknown error',
      'error in cleartax.in/webflow/preview/[partner]'
    );
    return render404Page();
  }
};

export default PartnerPage;
